export const BASKET_STATUS_IN_PROGRESS = 10;
export const BASKET_STATUS_SAVED = 20;
export const BASKET_STATUS_IN_REVIEW = 30;
export const BASKET_STATUS_CHECKOUT = 40;
export const BASKET_STATUS_ABANDONED = 50;
export const BASKET_STATUS_CANCELLED = 60;
export const BASKET_STATUS_COMPLETE = 70;
export const BASKET_STATUS_LOCKED = 80;
export const BASKET_STATUS_ARCHIVED = 90;
export const BASKET_STATUS_DELETED = 100;
export const BASKET_STATUS_ERROR = 110;

export const BASKET_STATUS_MESSAGES = {
  [BASKET_STATUS_IN_PROGRESS]: 'In progress',
  [BASKET_STATUS_SAVED]: 'Saved',
  [BASKET_STATUS_IN_REVIEW]: 'In review',
  [BASKET_STATUS_CHECKOUT]: 'Checkout',
  [BASKET_STATUS_ABANDONED]: 'Abandoned',
  [BASKET_STATUS_CANCELLED]: 'Cancelled',
  [BASKET_STATUS_COMPLETE]: 'Completed',
  [BASKET_STATUS_LOCKED]: 'Locked',
  [BASKET_STATUS_ARCHIVED]: 'Archived',
  [BASKET_STATUS_DELETED]: 'Deleted',
  [BASKET_STATUS_ERROR]: 'Error',
};

export const PAYMENT_OPTION_PLAN = 'PAYMENT_PLAN';
export const PAYMENT_OPTION_FULL = 'FULL';
